import { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box, Grid, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import EnumsGroupGrid from "../components/EnumsGroupGrid";
import LoaderComponent from "../components/LoaderComponent";
import {  loadEnumGroupEditData } from "../api/enumsgroupapi";
import { getEnumGroupSingleData, getEnumsGroupLoading } from '../selector/selectors';


const EditEnumsGroup = ({
    isLoading,
    enumGroupData,
    loadEnumGroupEditData
}) => {
    const params                            =   useParams();
    const [value, setValue]                 =   useState('1');

    useEffect(() => {
       loadEnumGroupEditData(params.id);
    }, [loadEnumGroupEditData,params.id]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
    <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
        <Grid container >
            <TabContext value={value}>
                <Grid item xs={12} md={12} lg={12} >
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="">
                            <Tab label="Edit Enum Groups Data" value="1" />
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{p:0,pt:2}}>
                        {enumGroupData.length > 0 &&
                            <EnumsGroupGrid
                                result={enumGroupData}
                            />
                        }
                    </TabPanel>
                </Grid>
            </TabContext>
        </Grid>
    </Box>
  );
}

const mapStateToProps = (state) => ({
    isLoading: getEnumsGroupLoading(state),  
    enumGroupData:getEnumGroupSingleData(state)
});
const mapDispatchToProps = (dispatch) => ({
    loadEnumGroupEditData:(id)      => dispatch(loadEnumGroupEditData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEnumsGroup); 